import React, { useState, useEffect, useContext, Fragment } from 'react';
import { distitoMateraAPI, apiURL } from '../../Util/apiURL';
import AuthContext from '../../store/auth-context';
import FlexContainer from '../TailwindUI/FlexContainer';
import { useHistory, useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { putEntrada, deleteEntrada } from '../../store/editEntrada-slice';
import { Modal } from '../HeadlessUI/Modal';

import { prettifyNumber } from '../../Util/prettifyNumber.js';
import {
  getCuentaPorPagar,
  getRelation,
  editCuentaPorPagarActions,
  deleteRelationProducto,
  postRelationProducto,
  deleteRelationPago,
  deleteCuentaPorPagar,
  deleteRelationNotaDeCredito,
} from '../../store/editarCuentaPorPagar-slice';
import AsignProductoToFindFromOcp from '../TailwindUI/AsignProductoToFindFromOcp';
import { CardButton } from '../SharedUi/UpdateCardUI';
import AsignProductoToEntrada from '../TailwindUI/AsignProductoToEntrada';
import AsignProductoEtoCPP from './AsignProductoEtoCPP';
import MateraIcon from '../../images/logo-mely.svg';
import DotsDropdown from '../DropdownMenu/DotsDropdown';
import DropdownItemButton from '../DropdownMenu/DropdownItemButton';
import ProductosCuentaPorPagar from './ProductosCuentaPorPagar';
import { TrashIcon, CurrencyDollarIcon } from '@heroicons/react/solid';
import ErrorModal from '../UI/Modals/ErrorModal';
import PagoModal from '../UI/Modals/PagoModal';
import { InputCornerHint, SelectCornerHint } from '../SharedUi/Inputs';
import { createPagoProveedorActions } from '../../store/crearPagoProveedor-slice';
import CreatePagoFromCpp from '../PagosProveedor/CreatePagoFromCpp';
import CreateNotaCreditoFromCpp from '../NotaDeCreditoProveedor/CreateNotaCreditoFromCpp';

import DocsCard from '../SharedUi/DocsCard';
import {
  DocsCardLayoutLogo,
  DocsCardLayoutDatosDoc,
  DocsCardLayoutMenu,
} from '../SharedUi/DocsCardLayout';

import IconButton from '../TailwindUI/IconButton';
import AbonosTable from './AbonosTable';
import PagosTable from './PagosTable';
import DeleteModal from '../UI/Modals/DeleteModal';
import Table from '../TailwindUI/Table';
import TableHeader from '../TailwindUI/TableHeader';
import TableBody from '../TailwindUI/TableBody';
import TableRow from '../TailwindUI/TableRow';
import TableRowHeader from '../TailwindUI/TableRowHeader';
import TableHeaderCell from '../TailwindUI/TableHeaderCell';
import TableBodyCell from '../TailwindUI/TableBodyCell';

const EditCuentaPorPagar = () => {
  const [isPagoModalOpen, setIsPagoModalOpen] = useState(false);
  const [deleteModalIsVisible, setDeleteModalIsVisible] = useState(false);
  const editEntradaState = useSelector((state) => state.editEntrada);
  const editCuentaPorPagar = useSelector((state) => state.editCuentaPorPagar);
  const [isAddProductoModalOpen, setIsAddProductoModalOpen] = useState(false);

  const relationsProductos = useSelector(
    (state) => state.editOrdenCompraProveedor.relationsProductos,
  );
  const asignedProducts = useSelector((state) => state.editOrdenCompraProveedor.asignedProducts);
  const dispatch = useDispatch();
  const apiHOST = apiURL();
  const { paramsById } = distitoMateraAPI;
  const authCtx = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();
  console.log('EDIT ENTRADA Stateeee-----');
  console.log(editEntradaState);

  const urlParam = location.pathname.split('/')[2];
  const putUrl = location.pathname.split('/')[1];

  const requestUrl = 'ordenes-compra-proveedor';
  const deleteUrl = `cuentas-por-pagar/${editCuentaPorPagar.cpp?.id}`;
  const relationProducto_URL = `views/cuentas-por-pagar/productos-entrada/for-cpp/?proveedorId=${editCuentaPorPagar.cpp?.proveedorId}&divisaId=${editCuentaPorPagar.cpp?.divisaId}&iva=${editCuentaPorPagar.cpp?.iva}`;
  const relationProductosCuentasPorPagar_URL = `views/productos-cuentas-por-pagar/${urlParam}`;
  const relationPagos = `views/pagos-proveedor/cpp/${urlParam}`;
  const relationNotasDeCredito = `views/notas-de-credito-proveedor/cpp/${urlParam}`;
  const relationTotalPagos = `views/pagos-proveedor/cpp/total/${urlParam}`;
  const relationTotalNotasDeCredito = `views/notas-de-credito-proveedor/cpp/total/${urlParam}`;

  const ordenCompraProveedorStateTree = editEntradaState;
  const putRequestObj = {
    numero_ocp: ordenCompraProveedorStateTree.ocp?.numeroOcp,
    proveedor_id: ordenCompraProveedorStateTree.ocp?.proveedorId,
    iva: ordenCompraProveedorStateTree.ocp?.iva,
    usuario_id: ordenCompraProveedorStateTree.ocp?.usuarioId,
    divisa_id: ordenCompraProveedorStateTree.ocp?.divisaId,
    inventario_id: ordenCompraProveedorStateTree.ocp?.inventarioId,
    en_calidad_de_id: ordenCompraProveedorStateTree.ocp?.enCalidadDeId,
    estatus: ordenCompraProveedorStateTree.ocp?.estatus,
    cantidad_letra: ordenCompraProveedorStateTree.ocp?.cantidadLetra,
  };

  const [useEffectVariable, setUseEffectVariable] = useState(0);
  const [tipoDeAbono, setTipoDeAbono] = useState('pago');
  const fetchCuentaPorPagar = () => {
    dispatch(getCuentaPorPagar({ urlParam, authCtx }));
  };
  useEffect(() => {
    fetchCuentaPorPagar();
    getRelationHandler(relationProductosCuentasPorPagar_URL, 'productosCuentaPorPagar');
  }, []);

  useEffect(() => {
    fetchCuentaPorPagar();
    getRelationHandler(relationPagos, 'pagosProveedor');
    getRelationHandler(relationTotalPagos, 'totalPagosProveedor');
    getRelationHandler(relationNotasDeCredito, 'notasDeCreditoProveedor');
    getRelationHandler(relationTotalNotasDeCredito, 'totalNotasDeCreditoProveedor');
    getRelationHandler(relationProductosCuentasPorPagar_URL, 'productosCuentaPorPagar');
  }, [useEffectVariable]);

  const handleResetProductosOrdenescompra = () => {
    dispatch(editCuentaPorPagarActions.resetProductosOrdenCompra());
  };

  const handlePutOrdenCompraProveedor = () => {
    dispatch(
      putEntrada({
        requestObj: putRequestObj,
        requestUrl,
        reduxStateTree: ordenCompraProveedorStateTree,
        history,
        authCtx,
      }),
    );
  };

  const handleDelete = () => {
    console.log({
      requestUrl: deleteUrl,
      editCuentaPorPagar,
      history,
    });
    dispatch(
      deleteCuentaPorPagar({
        requestUrl: deleteUrl,
        editCuentaPorPagar,
        history,
        authCtx,
      }),
    );
    console.log('handle delete----->>>>>>>');
    console.log('handle delete----->>>>>>>');
    console.log('handle delete----->>>>>>>');
  };

  //Relations
  ////Redux Actions
  const handleAsingProducto = (e) => {
    dispatch(editCuentaPorPagarActions.asign({ ...e }));
  };
  const handleCancelAsingProducto = (e) => {
    dispatch(editCuentaPorPagarActions.cancelAsign({ ...e }));
  };
  //Relations AsyncTHunks

  const getRelationHandler = (requestUrl, reduxStateTree) => {
    dispatch(
      getRelation({
        requestUrl,
        reduxStateTree,
        authCtx,
      }),
    );
  };
  const handleEraseRelation = (e) => {
    console.log('errase producto_cpp');
    console.log(e);

    const requestObj = {
      id: e.valueToUnasign.pcppId,
    };
    const { reduxStateTree, asignedListString, asignedListSelector } = e;
    console.log('reduxStateTree');
    console.log(reduxStateTree);
    console.log('requestObj-->>');
    console.log(requestObj);

    dispatch(
      deleteRelationProducto({
        requestObj,
        reduxStateTree,
        asignedListString,
        asignedListSelector,
        authCtx,
      }),
    );
    setUseEffectVariable(useEffectVariable + 1);
  };
  const handleErrasePago = (e) => {
    console.log('errase PAGO');
    console.log(e);

    const requestObj = {
      id: e.valueToUnasign.id,
    };
    const { reduxStateTree, asignedListString, asignedListSelector } = e;
    console.log('reduxStateTree');
    console.log(reduxStateTree);
    console.log('event');
    console.log(e);

    dispatch(
      deleteRelationPago({
        requestObj,
        reduxStateTree,
        asignedListString,
        asignedListSelector,
        authCtx,
      }),
    );
    setUseEffectVariable(useEffectVariable + 1);
    getRelationHandler(relationPagos, 'pagosProveedor');
    getRelationHandler(relationTotalPagos, 'totalPagosProveedor');
  };

  const handleErraseNotaDeCredito = (e) => {
    const requestObj = {
      id: e.valueToUnasign.id,
    };
    const { reduxStateTree, asignedListString, asignedListSelector } = e;
    console.log('reduxStateTree');
    console.log(reduxStateTree);
    console.log('event');
    console.log(e);

    dispatch(
      deleteRelationNotaDeCredito({
        requestObj,
        reduxStateTree,
        asignedListString,
        asignedListSelector,
        authCtx,
      }),
    );
    setUseEffectVariable(useEffectVariable + 1);
    getRelationHandler(relationNotasDeCredito, 'notasDeCreditoProveedor');
    getRelationHandler(relationTotalNotasDeCredito, 'totalNotasDeCreditoProveedor');
  };

  const handleSelect = (reduxStateTree, value, selectValues) => {
    handleResetProductosOrdenescompra();
    return editCuentaPorPagarActions.select({
      field: reduxStateTree,
      selectedValue: value,
      values: selectValues,
    });
  };

  const handlePostRelation = (e) => {
    dispatch(editCuentaPorPagarActions.resetProductosEntrada());
    let requestObj = {};
    const { reduxStateTree, selectedValue, asignedListString } = e;
    console.log('reduxStateTree----------');
    console.log(reduxStateTree);
    if (reduxStateTree === 'productToAsign') {
      requestObj = { ...selectedValue };
    }
    dispatch(
      postRelationProducto({
        requestObj,
        reduxStateTree,
        selectedValue,
        asignedListString,
        authCtx,
      }),
    );

    setUseEffectVariable(useEffectVariable + 1);
    getRelationHandler(relationProductosCuentasPorPagar_URL, 'productosCuentaPorPagar');
    setIsAddProductoModalOpen(false);
  };
  const handleAsignCppToPagoProveedor = (cpp) => {
    console.log('handleAsignCppToPagoProveedor!!!!!!!___++++++');
    console.log(cpp);
    dispatch(createPagoProveedorActions.setCpp(cpp));
  };

  const handleCantidadLetra = (e) => {
    dispatch(
      editCuentaPorPagarActions.change({
        field: 'cantidadLetra',
        value: e.target.value,
      }),
    );
  };
  const handleDate = (e) => {
    dispatch(
      editCuentaPorPagarActions.change({
        field: 'fechaEntrega',
        value: e.target.value,
      }),
    );
  };
  const handleCreateCuentaPorPagar = async (request) => {
    console.log('Create cuenta por pagar');
    console.log(request);

    try {
      const response = await axios.post(`${apiHOST}views/cuentas-por-pagar`, request);
      console.log('response Create cuenta por Pagar');
      console.log(response);
      return history.push(`/cuentas-por-pagar/${response.data.id}`);
    } catch (err) {
      return err;
    }
  };
  const handleCloseModal = () => {
    setIsPagoModalOpen(false);
    setUseEffectVariable(useEffectVariable + 1);
  };
  const handleTipoDeAbono = (e) => {
    if (e.target.value === 'pago') {
      setTipoDeAbono('pago');
      return;
    }
    if (e.target.value === 'notaDeCredito') {
      setTipoDeAbono('notaDeCredito');
      return;
    }
  };

  const divisa = {
    id: editCuentaPorPagar?.cpp?.divisaId,
    nombre: editCuentaPorPagar?.cpp?.divisa,
  };
  const totalPagosProveedor = editCuentaPorPagar?.totalPagosProveedor?.totalPagosProveedorByCpp
    ? editCuentaPorPagar?.totalPagosProveedor?.totalPagosProveedorByCpp
    : 0;
  const totalCpp = Number(editCuentaPorPagar?.cpp?.total);
  const totalPagosYNotas =
    Number(
      editCuentaPorPagar?.totalPagosProveedor?.totalPagosProveedorByCpp
        ? editCuentaPorPagar?.totalPagosProveedor?.totalPagosProveedorByCpp
        : 0,
    ) +
    Number(
      editCuentaPorPagar?.totalNotasDeCreditoProveedor?.totalNotasDeCreditoProveedorByCpp
        ? editCuentaPorPagar?.totalNotasDeCreditoProveedor?.totalNotasDeCreditoProveedorByCpp
        : 0,
    );

  return (
    <>
      {deleteModalIsVisible && (
        <DeleteModal
          title={'Borrar CCP'}
          onConfirm={(editCuentaPorPagar) => {
            console.log('click');

            handleDelete(editCuentaPorPagar?.cpp?.id);

            setDeleteModalIsVisible(false);
          }}
          onCancel={() => setDeleteModalIsVisible(false)}
        >
          Esta Acción no puede desacerse
        </DeleteModal>
      )}

      {isPagoModalOpen && (
        <PagoModal
          title={`ABONO A CUENTA POR PAGAR --->  ${editCuentaPorPagar?.cpp?.razonSocial?.toUpperCase()}`}
          onConfirm={() => {
            handleCloseModal();
          }}
        >
          <div>
            <div style={{maxWidth:'90vw' , overflow:'auto', margin:'auto'}}>



            <Table>
              <TableHeader>
                <TableRowHeader>
                  <TableHeaderCell textAlign="text-center">CPP</TableHeaderCell>
                  <TableHeaderCell textAlign="text-center">FACTURA</TableHeaderCell>

                  <TableHeaderCell textAlign="text-center">DIVISA</TableHeaderCell>
                  <TableHeaderCell textAlign="text-center">SUBTOTAL</TableHeaderCell>
                  {editCuentaPorPagar?.cpp?.iva && (
                    <TableHeaderCell textAlign="text-center">IVA</TableHeaderCell>
                  )}
                  <TableHeaderCell textAlign="text-center">TOTAL</TableHeaderCell>
                  <TableHeaderCell textAlign="text-center">PENDIENTE</TableHeaderCell>
                </TableRowHeader>
              </TableHeader>
              <TableBody>
                <TableRow
                  className={
                    editCuentaPorPagar?.cpp?.diasRestantes < 0 ? 'bg-red-200' : 'bg-gray-100'
                  }
                >
                  <TableBodyCell textAlign="text-center">
                    {editCuentaPorPagar?.cpp?.id}
                  </TableBodyCell>

                  <TableBodyCell textAlign="text-center">
                    {editCuentaPorPagar?.cpp?.factura}
                  </TableBodyCell>

                  <TableBodyCell textAlign="text-center">
                    <span className="uppercase font-bold text-lg">
                      {editCuentaPorPagar?.cpp?.divisa}
                    </span>
                  </TableBodyCell>
                  <TableBodyCell textAlign="text-center">
                    ${prettifyNumber(editCuentaPorPagar?.cpp?.subtotal)}
                  </TableBodyCell>
                  {editCuentaPorPagar?.cpp?.iva && (
                    <TableBodyCell textAlign="text-center">
                      ${prettifyNumber(editCuentaPorPagar?.cpp?.subtotal * 0.16)}
                    </TableBodyCell>
                  )}
                  <TableBodyCell textAlign="text-center">
                    ${prettifyNumber(editCuentaPorPagar?.cpp?.total)}
                  </TableBodyCell>
                  <TableBodyCell textAlign="text-center">
                    ${prettifyNumber((totalCpp - totalPagosYNotas).toFixed(2))}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
            </Table>

            </div>
            <div className=" my-4 p-4 bg-orange-100" style={{ position: 'sticky', top: '50px' }}>
              <SelectCornerHint
                value={tipoDeAbono}
                onChange={handleTipoDeAbono}
                onBlur={handleTipoDeAbono}
                label={'Tipo de Abono'}
                options={[
                  <option value={'pago'}>Pago</option>,
                  <option value={'notaDeCredito'}>Nota De Crédito</option>,
                ]}
              ></SelectCornerHint>
            </div>

            {tipoDeAbono === 'pago' && (
              <CreatePagoFromCpp
                onConfirm={() => {
                  handleCloseModal();
                  getRelationHandler(relationPagos, 'pagosProveedor');
                  getRelationHandler(relationTotalPagos, 'totalPagosProveedor');
                }}
                divisa={divisa}
                totalPagosYNotas={totalPagosYNotas}
                totalCpp={totalCpp}
                totalPagosProveedor={totalPagosProveedor}
              />
            )}
            {tipoDeAbono === 'notaDeCredito' && (
              <CreateNotaCreditoFromCpp
                divisa={divisa}
                onConfirm={() => {
                  handleCloseModal();
                  getRelationHandler(relationNotasDeCredito, 'notasDeCreditoProveedor');
                  getRelationHandler(relationTotalNotasDeCredito, 'totalNotasDeCreditoProveedor');
                }}
                cpp={editCuentaPorPagar?.cpp}
                totalCpp={totalCpp}
                totalPagosYNotas={totalPagosYNotas}
                totalPagosProveedor={totalPagosProveedor}
              />
            )}
          </div>
        </PagoModal>
      )}

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Main content */}
        <FlexContainer className="flex-1 items-stretch  overflow-hidden">
          <main className="flex-1 overflow-y-auto">
            {/*TAB CODE */}
            {/*TAB CODE*/}
            {/* Primary column */}
            {/* <div>{JSON.stringify(editCuentaPorPagar)}</div> */}
            <FlexContainer className="flex-col">
              <div>
                <DocsCard>
                  <DocsCardLayoutMenu>
                    {editCuentaPorPagar.productosCuentaPorPagar.length === 0 ? (
                      <DotsDropdown vigente={true}>
                        <DropdownItemButton onClick={() => setDeleteModalIsVisible(true)}>
                          <TrashIcon
                            className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                            aria-hidden="true"
                          />
                          Borrar CPP
                        </DropdownItemButton>
                      </DotsDropdown>
                    ) : (
                      ''
                    )}
                  </DocsCardLayoutMenu>
                  <DocsCardLayoutLogo>
                    <div className="text-sm text-left  ">
                      <div>
                        Razon Social{' '}
                        <span className="font-medium">
                          {editCuentaPorPagar?.cpp?.razonSocial?.toUpperCase()}
                        </span>
                      </div>
                      <div className="mt-d2">
                        Divisa
                        <span className="bg-purple-100 text-purple-600 rounded-xl font-medium px-6 py-1">
                          {editCuentaPorPagar?.cpp?.divisa?.toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </DocsCardLayoutLogo>
                  <DocsCardLayoutDatosDoc>
                    <div className="col-span-1 text-sm text-right ml-auto ">
                      <div>
                        <span className="mr-2">Cuenta por pagar:</span>
                        <span className="font-medium">{editCuentaPorPagar?.cpp?.id}</span>
                      </div>
                      <div>
                        <span className="mr-2">Factura:</span>
                        <span className="font-medium">{editCuentaPorPagar?.cpp?.factura}</span>
                      </div>
                      <div>
                        <span className="mr-2">Días Restantes</span>
                        <span className="font-medium">
                          {editCuentaPorPagar?.cpp?.diasRestantes}
                        </span>
                      </div>
                      <div>
                        <span className="mr-2">Fecha Factura:</span>
                        <span className="font-medium">{editCuentaPorPagar?.cpp?.fechaFactura}</span>
                      </div>
                      <div>
                        <span className="mr-2">Fecha Vencimiento:</span>
                        <span className="font-medium">
                          {editCuentaPorPagar?.cpp?.fechaVencimiento}
                        </span>
                      </div>
                    </div>
                  </DocsCardLayoutDatosDoc>
                </DocsCard>

                <DocsCard>
                  <div className="tex-center col-span-6">
                    <Modal
                      dispatchClose={() => {
                        setIsAddProductoModalOpen(false);
                      }}
                      isOpen={isAddProductoModalOpen}
                      openButton={
                        editCuentaPorPagar.cpp?.proveedorId && (
                          <IconButton
                            onClick={() => {
                              getRelationHandler(relationProducto_URL, 'productosEntrada');
                              setIsAddProductoModalOpen(true);
                            }}
                            color="orangeMely"
                            icon="+"
                          />
                        )
                      }
                      title={'Productos en Cuenta por Pagar'}
                      body={
                        <>
                          <AsignProductoEtoCPP
                            //UI
                            cardTitle={
                              editEntradaState?.productToSearch?.simbolo
                                ? `Entradas Sin Asignar Cuenta Por Pagar`
                                : ''
                            }
                            inputLabel={'Añade Productos'}
                            //Redux
                            asignTree={'productToAsign'}
                            valueToAsignSelector={editCuentaPorPagar?.productToAsign}
                            asignedListSelector={editCuentaPorPagar?.productosEntrada}
                            asignedListString={'productosCuentaPorPagar'}
                            entradaId={urlParam}
                            factura={editCuentaPorPagar?.cpc?.factura}
                            proveedorId={editCuentaPorPagar?.proveedorId}
                            cuentaPorPagar={editCuentaPorPagar?.cpp}
                            //Function Handlers
                            handleCantidadLetra={handleCantidadLetra}
                            handleSelect={handleAsingProducto}
                            handleCancel={handleCancelAsingProducto}
                            handlePostRelation={handlePostRelation}
                            handleUpdate={handlePutOrdenCompraProveedor}
                          />
                          {editCuentaPorPagar?.productosEntrada
                            ? editCuentaPorPagar?.productosEntrada?.length === 0 && (
                                <div className="text-red-400">
                                  No se encontraron productos por añadir
                                </div>
                              )
                            : ''}
                        </>
                      }
                    />
                  </div>
                  <div className="col-span-6 mt-4">
                    <>
                      <div className="text-left mb-2 text-gray-600">
                        PRODUCTOS EN CUENTA POR PAGAR
                      </div>

                      <ProductosCuentaPorPagar
                        //Redux
                        asignedListSelector={editCuentaPorPagar?.productosCuentaPorPagar}
                        asignTree={'productToAsign'}
                        asignedListString={'productosCuentaPorPagar'}
                        subtotal={editCuentaPorPagar.cpp?.subtotal}
                        iva={editCuentaPorPagar.cpp?.iva}
                        total={editCuentaPorPagar.cpp?.total}
                        //Function Handlers
                        handleErrase={handleEraseRelation}
                      />
                    </>
                  </div>
                </DocsCard>
                <DocsCard>
                  <DocsCardLayoutMenu>
                    {Math.floor(totalCpp) - Math.floor(totalPagosYNotas) === 0 ||
                    Math.floor(totalCpp) - Math.floor(totalPagosYNotas) === 1 ||
                    Math.floor(totalCpp) - Math.floor(totalPagosYNotas) === -1 ? (
                      ''
                    ) : (
                      <DotsDropdown vigente={true}>
                        <DropdownItemButton
                          onClick={() => {
                            handleAsignCppToPagoProveedor(editCuentaPorPagar.cpp);
                            setIsPagoModalOpen(true);
                          }}
                        >
                          <CurrencyDollarIcon
                            className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                            aria-hidden="true"
                          />
                          CREAR ABONO
                        </DropdownItemButton>
                      </DotsDropdown>
                    )}
                  </DocsCardLayoutMenu>
                  <div className="col-span-6 mt-4">
                    <div className=" font-medium text-left mb-4 ">ABONOS A CUENTA POR PAGAR</div>
                    <div style={{ maxWidth: '300px' }}>
                      <div className=" text-left mb-12 text-gray-600">
                        <Table>
                          <TableHeader>
                            <TableRow>
                              <TableHeaderCell className="text-gray-600 px-1">
                                Descripción
                              </TableHeaderCell>
                              <TableHeaderCell className="text-gray-600 px-1">
                                Monto
                              </TableHeaderCell>
                            </TableRow>
                          </TableHeader>
                          <TableBody>
                            <TableRow className="bg-white border">
                              <TableBodyCell className="text-gray-800 px-1">Total</TableBodyCell>
                              <TableBodyCell className="text-gray-800 px-1">
                                <div>${prettifyNumber(totalCpp)}</div>
                              </TableBodyCell>
                            </TableRow>
                            <TableRow className="bg-white border">
                              <TableBodyCell className="text-gray-800 px-1">Suma Abonos</TableBodyCell>
                              <TableBodyCell className="text-gray-800 px-1">
                                <div>${prettifyNumber(totalPagosYNotas.toFixed(2))}</div>
                              </TableBodyCell>
                            </TableRow>
                            <TableRow className="bg-white border">
                              <TableBodyCell className="text-gray-800 px-1">Saldo Pendiente</TableBodyCell>
                              <TableBodyCell
                                //TODO REVIEW THIS LOGIC SO WE CAN SITLL PAY SOMETHING THAT IS NOT 0

                                className={
                                  Math.floor(totalCpp) - Math.floor(totalPagosYNotas) === 0 ||
                                  Math.floor(totalCpp) - Math.floor(totalPagosYNotas) === 1 ||
                                  Math.floor(totalCpp) - Math.floor(totalPagosYNotas) === -1
                                    ? '  bg-green-100 text-green-600 font-medium  px-1 py-1'
                                    : '  bg-yellow-100 text-gray-600 font-medium  px-1 py-1'
                                }
                              >
                                <div>
                                  ${prettifyNumber((totalCpp - totalPagosYNotas).toFixed(2))}
                                </div>
                              </TableBodyCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </div>
                    </div>

                    <div className={' my-4 text-left text-gray-600'}>
                      PAGOS
                      {/* {editCuentaPorPagar.cpp?.proveedorId && (
                        <IconButton
                          onClick={() => {
                            handleAsignCppToPagoProveedor(
                              editCuentaPorPagar.cpp
                            );
                            setIsPagoModalOpen(true);
                          }}
                          color="orangeMely"
                          icon="+"
                          iconHeight={2.5}
                          iconWidth={2.5}
                        />
                      )} */}
                    </div>
                    <PagosTable
                      divisa={divisa}
                      modalTitle={'Borrar pago'}
                      //Redux
                      asignedListSelector={editCuentaPorPagar?.pagosProveedor}
                      asignTree={'productToAsign'}
                      asignedListString={'pagosProveedor'}
                      total={editCuentaPorPagar?.totalPagosProveedor?.totalPagosProveedorByCpp}
                      //Function Handlers

                      handleErrase={handleErrasePago}
                    />

                    <div className=" my-4 text-left text-gray-600">NOTAS DE CREDITO</div>

                    <PagosTable
                      divisa={divisa}
                      modalTitle={'Borrar nota de crédito'}
                      //Redux
                      asignedListSelector={editCuentaPorPagar?.notasDeCreditoProveedor}
                      asignTree={'productToAsign'}
                      asignedListString={'notasDeCreditoProveedor'}
                      total={
                        editCuentaPorPagar?.totalNotasDeCreditoProveedor
                          ?.totalNotasDeCreditoProveedorByCpp
                      }
                      //Function Handlers
                      handleErrase={handleErraseNotaDeCredito}
                    />
                  </div>
                </DocsCard>
              </div>
            </FlexContainer>
          </main>
        </FlexContainer>

        {
          //#region Productos Entrada
        }
      </div>
    </>
  );
};
export default EditCuentaPorPagar;
